import React from "react";
import axios from "axios";

export const handleAxiosErrors = response => {
  if (!response || response.status !== 200) {
    throw Error(response.status);
  }
  return response.data;
};

export const getRessource = (url, abort) =>
  axios
    .get(url, {
      signal: abort.signal,
    })
    .then(response => handleAxiosErrors(response))
    .catch(error => Promise.reject(error));

export const setLogoFromDsp = elem => (
  <img src={require(`../assets/${elem.logo}`)} alt={elem.libelle} className="logo-dsp" />
);
